import { useDialogFrameDimensions } from "./hooks/useDialogFrameDimensions";

interface CalendlyErrorProps {
  onRetry: VoidFunction;
}

export const CalendlyError = ({ onRetry }: CalendlyErrorProps) => {
  const { dialogFrameHeight } = useDialogFrameDimensions();

  return (
    <div className="flex flex-col items-center justify-center py-16" style={{ height: dialogFrameHeight - 320 }}>
      <div className="text-center">
        <h2 className="mb-4 text-2xl font-semibold text-gray-900">Oops, something went wrong.</h2>
        <p className="mb-8 text-gray-600">Server error. Please check your connection.</p>
        <button
          onClick={onRetry}
          className="w-full rounded-full bg-blue-600 py-3 font-medium text-white transition-colors duration-200 hover:bg-blue-700"
        >
          Try Again
        </button>
      </div>
    </div>
  );
};
